<template>
  <span v-if="isDev" :class="['ui-debug', { 'ui-debug--badge': badge }]">
    <slot />
  </span>
</template>

<script setup lang="ts">
interface Props {
  /** Показувати як бейдж (position: absolute, top-left, напівпрозорий фон) */
  badge?: boolean
}

withDefaults(defineProps<Props>(), {
  badge: false
})

const isDev = import.meta.dev
</script>

<style scoped>
.ui-debug {
  font-family: var(--font-inter);
  font-size: 12px;
}

.ui-debug--badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 9999;
  padding: 4px 8px;
  background: #c00;
  color: #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
</style>
